import { createAction } from '@reduxjs/toolkit'
import { ActionTypes_Bookings } from './TActions'
import { TBookingFilters, TFutureBooking, TPickUpParkingsFilters } from './TReducer'
import { TStoreTemplateWithFilter } from 'redux/config/root-types'
import { IParking } from '../parkings/TReducer'
import { TCurrentBooking } from 'utils/types/TCurrentBooking'
import { ISagaWorker_CancelBooking } from 'redux/sagas/events/bookings/SagaWorker_CancelBooking'

const { StoreActions, SagaEvents } = ActionTypes_Bookings

export const Actions_Bookings = {
  saga: {
    loadPage: createAction(SagaEvents.LOAD_PAGE),
    getBookings: createAction(SagaEvents.GET_BOOKINGS),
    getBookingsXlsx: createAction(SagaEvents.GET_BOOKINGS_XLSX),
    getPickUpParkings: createAction<TPickUpParkingsFilters>(SagaEvents.GET_PICK_UP_PARKINGS),
    getBookingDetails: createAction<any>(SagaEvents.GET_BOOKING_DETAILS),
    cancelBooking: createAction<ISagaWorker_CancelBooking>(SagaEvents.CANCEL_BOOKING),
  },

  store: {
    showLoader: createAction(StoreActions.IS_LOADER_SHOW),
    hideLoader: createAction(StoreActions.IS_LOADER_HIDE),
    saveBookings: createAction<TStoreTemplateWithFilter<TFutureBooking[]>>(StoreActions.SAVE_BOOKINGS),
    changeFilter: createAction<TBookingFilters>(StoreActions.CHANGE_FILTER),
    increaseFilterOffset: createAction<TBookingFilters>(StoreActions.INCREASE_FILTER_OFFSET),
    reset: createAction(StoreActions.RESET),
    savePickUpParkings: createAction<IParking[]>(StoreActions.SAVE_PICK_UP_PARKINGS),
    setSelectedPickUpParking: createAction<IParking | null>(StoreActions.SET_SELECTED_PICK_UP_PARKING),
    setSelectedTrailerTypeId: createAction<number | null>(StoreActions.SET_SELECTED_TRAILER_TYPE_ID),
    setCurrentBooking: createAction<TCurrentBooking | null>(StoreActions.SET_CURRENT_BOOKING),
  },
}
